import React, { useState, useEffect } from 'react'
import { View } from '@instructure/ui-view'
import { Loading } from '../../components/loading/Loading.jsx'
import Error from '../../components/error/Error.jsx'
import { Heading } from '@instructure/ui-heading'
import { connect } from 'react-redux'
import AddSections from '../../components/addSections/AddSections.jsx'
import ManageUsers from '../../components/manageUsers/ManageUsers.jsx'
import ManageSections from '../../components/manageSections/ManageSections.jsx'
import { getSections, getCourseUsers, getEnrollment } from '../../actions/courses'
import { Flex } from "@instructure/ui-flex"
import FilterBySearch from '../../components/filterUsers/FilterBySearch.jsx'
import UsersPagination from '../../components/usersPagination/UsersPagination.jsx'
import { Text } from '@instructure/ui-text'

const Home = ({ loading, courseId, token, getCourseUsers, getSections }) => {
  const [error, _setError] = useState(null)

  useEffect(() => {
    getCourseUsers(courseId, token)
    getSections(courseId, token)
    getEnrollment(courseId, token)
  }, [courseId, token])

  const handleFilter = (value) => {
    if (value.length > 2) {
      getCourseUsers(courseId, token, false, value)
    } else {
      getCourseUsers(courseId, token)
    }
  }

  if (loading) {
    return (
      <View>
        <Loading />
      </View>
    )
  }

  return (
    <View padding="small" as="div">
      <Error message={error}>
        <Heading level="h1" margin="medium 0 medium 0">Manage Sections</Heading>
        <Flex>
          <Flex.Item size="25%" padding="small x-small" align="start">
            <Text as="h2" size='large' weight="bold" id='users-header'>Users</Text>
            <FilterBySearch handleFilterSearch={handleFilter} />
            <ManageUsers />
            <UsersPagination />
          </Flex.Item>
          <Flex.Item size="75%" padding="small x-small" align="start">
            <Text as="h2" size='large' weight="bold" id='sections-header'>Sections</Text>
            <AddSections />
            <ManageSections />
          </Flex.Item>
        </Flex>
      </Error>
    </View>
  );
}

const mapStateToProps = (state) => {
  const { userAccess: { jwtToken }, courses: { users, sections }, canvas: { canvasCourse } } = state
  return {
    courseId: canvasCourse && canvasCourse.courseId,
    courseName: canvasCourse && canvasCourse.courseName,
    paginatedUsers: (users && users.result && users.result.links) || [],
    token: jwtToken,
    users,
    sections
  }
}

export default connect(mapStateToProps, { getSections, getCourseUsers, getEnrollment })(Home)